import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import ArrowDisabler from "./ArrowDisabler";
import Modal from "./Modal";

class MobileLightbox{
    constructor(){
        this.wrapper = document.querySelector("#lightboxMobile");
        if(this.wrapper){
            const _this = this;
            this.glide = this.initGlide();
            if(this.glide){
                this.onGlideSlide(this.glide);
                this.closeOnClick();
            }
        }
    }

    initGlide(){
        const glideEl = this.wrapper.querySelector(".glide");
        var glide = null;
        if (glideEl) {
            glide = new Glide(glideEl, {
            perView: 1,
            gap: 0,
            type: 'slider',
            rewind: true,
            bound: true,
            });

            glide.mount({ Controls, Breakpoints, Swipe, ArrowDisabler });

            return glide;
        }
    }

    onGlideSlide(glide){
        let photoNumber = document.getElementById("photoNumber");
        if(glide){
          glide.on("run.after", function () {
            let glideIndex = glide.index;
            if (photoNumber) {
              photoNumber.textContent = glideIndex + 1;
            }

            window.setTimeout(function () {
              const activeSlide = document.querySelector("#lightboxMobile .glide__slide--active");
              if (activeSlide) {
                let experienceID = activeSlide.dataset.experienceId;
                let currentExperience = document.querySelector("#lightboxMobile .currentExperience:not(.hidden)");
                if(currentExperience && currentExperience.dataset.experienceId != experienceID){
                  currentExperience.classList.toggle("hidden");
                  let experienceToActive = document.querySelector("#lightboxMobile .currentExperience[data-experience-id='" + experienceID + "']");
                  if(experienceToActive){
                    experienceToActive.classList.toggle("hidden");
                  }
                }
              }
            }, 100);
          });
        }
    }

    closeOnClick(){
      const photos = document.querySelectorAll(".closeOnClick");
      photos.forEach(function(photo){
        photo.addEventListener("click", function(){
          Modal.closeAllModals();
        });
      });
    }
}

export default MobileLightbox;
